namespace Solovis.UI {

    export interface ElementSizerTargetSizeable {
        setWidth?: (newWidth) => void;
        setHeight?: (newHeight) => void;

        hasBeenRemovedFromDom(): boolean;
    }    

    export interface ElementSizerOptions {

        widthSourceElement?: JQuery | HTMLElement;
        heightSourceElement?: JQuery | HTMLElement;

        desiredWidth: () => number;
        desiredHeight: () => number;

        targetElement?: JQuery | HTMLElement;
        target?: ElementSizerTargetSizeable;

        /**
         * If useTimer is true, the element size will be re-evaluated on a regular interval. This can be used for edge cases
         * where we have no good means of doing change detection on a size dependency.
         */
        useTimer?: boolean;
    }

    /**
     * Dynamically monitor and just the size of an element based on some other criteria.
     */
    export class ElementSizer {

        private _options: ElementSizerOptions;

        private _windowResizeCallback;
        private _intervalHandler;

        private _lastWidth: number;
        private _lastHeight: number;

        constructor(options: ElementSizerOptions) {
            this._options = options;

            this._registerForEvents();
        }

        private _registerForEvents() {
            let self = this;
            let updateSizeDebounced = _.debounce(function () { self.updateSize(); }, 300);

            this._windowResizeCallback = function () {
                updateSizeDebounced();
            };            

            $(window).bind("resize", this._windowResizeCallback);

            if (this._options.useTimer) {
                this._intervalHandler = setInterval(function () {
                    updateSizeDebounced();
                }, 1000);
            }
        }

        private updateSize() {
            if (this._options.targetElement) {
                if (!Solovis.UI.DomHelper.isDescendantOf(this._options.targetElement, document.body)) {
                    this._unregisterEvents();
                    return;
                }
            }
            if (this._options.target) {
                if (this._options.target.hasBeenRemovedFromDom()) {
                    this._unregisterEvents();
                    return;
                }
            }

            let newWidth: number = null;
            let newHeight: number = null;

            if (this._options.widthSourceElement) {
                newWidth = $(this._options.widthSourceElement).outerWidth();
            }

            if (this._options.desiredWidth) {
                newWidth = this._options.desiredWidth();
            }            

            if (Solovis.isNotNull(newWidth) && this._lastWidth != newWidth) {
                this._lastWidth = newWidth;

                if (this._options.targetElement) {
                    $(this._options.targetElement).outerWidth(newWidth);
                }

                if (this._options.target && this._options.target.setWidth) {
                    this._options.target.setWidth(newWidth);
                }
            }

            // We process height after width since a change in width can affect available height
            // if the width change triggers a scrollbar visibility change.
            if (this._options.heightSourceElement) {
                newHeight = $(this._options.heightSourceElement).outerHeight();
            }

            if (this._options.desiredHeight) {
                newHeight = this._options.desiredHeight();
            }            

            if (Solovis.isNotNull(newHeight) && this._lastHeight != newHeight) {
                this._lastHeight = newHeight;

                if (this._options.targetElement) {
                    $(this._options.targetElement).outerHeight(newHeight);
                }

                if (this._options.target && this._options.target.setHeight) {
                    this._options.target.setHeight(newHeight);
                }
            }
        }

        private _unregisterEvents() {
            if (this._windowResizeCallback) {
                $(window).unbind("resize", this._windowResizeCallback);
                this._windowResizeCallback = null;
            }

            if (this._intervalHandler) {
                clearInterval(this._intervalHandler);
                this._intervalHandler = null;
            }
        }
    }

}